<span *ngIf="formGroup.controls[control.Name] && formGroup.controls[control.Name].invalid">
    <span class="text-danger" *ngIf="formGroup.controls[control.Name].errors?.['required']">
        {{control.DisplayName | translate}} {{'IsRequired' | translate}}
    </span>
    <span class="text-danger" *ngIf="formGroup.controls[control.Name].errors?.['email']">
        {{'Emailaddressisinvalid' | translate}}
    </span>
    <span class="text-danger" *ngIf="formGroup.controls[control.Name].errors?.['pattern']">
        {{control.DisplayName | translate}} {{'inputIsNotInACorrectFormat' | translate}}
    </span>
    <span class="text-danger"
        *ngIf="formGroup.controls[control.Name].errors?.['noWhiteSpace']&&(!formGroup.controls[control.Name].errors?.['pattern'])">
        {{control.DisplayName | translate}} {{'cantBeEmpty' | translate}}
    </span>
    <span class="text-danger" *ngIf="formGroup.controls[control.Name].errors?.['max']">
        {{control.DisplayName | translate}} {{'maxValueIs'|translate}}
        {{formGroup.controls[control.Name].errors?.['max']?.['max']}}
    </span>
    <span class="text-danger" *ngIf="formGroup.controls[control.Name].errors?.['min']">
        {{control.DisplayName | translate}} {{'minValueIs'|translate}}
        {{formGroup.controls[control.Name].errors?.['min']?.['min']}}
    </span>
    <span class="text-danger" *ngIf="formGroup.controls[control.Name].errors?.['maxlength']">
        {{control.DisplayName | translate}} {{'maxLenghtIs'|translate}}
        {{formGroup.controls[control.Name].errors?.['maxlength']?.['requiredLength']}}
    </span>
    <span class="text-danger" *ngIf="!formGroup.controls[control.Name].errors?.['required'] && formGroup.controls[control.Name].errors?.['whitespace']">
        {{control.DisplayName | translate}} {{'PleaseEnterValidData'|translate}}
    </span>
    <span class="text-danger" *ngIf="formGroup.controls[control.Name].errors?.['mask']">
      {{'Invalid'|translate}}
      {{control.DisplayName | translate}}
      {{'Length' | translate}}
    </span>
    <span class="text-danger" *ngIf="formGroup.controls[control.Name].errors?.['minlength']">
        {{'TooShortPassword' | translate}} {{formGroup.controls[control.Name].errors?.['minlength']?.requiredLength}} {{' '}} {{'Digits'|translate}}
      </span>

      <span class="text-danger" *ngIf="!formGroup.controls[control.Name].errors?.['minlength'] && formGroup.controls[control.Name].hasError('WeakPassword')">
        {{'PasswordTooWeak' | translate}}
      </span>

      <span class="text-danger" *ngIf="!formGroup.controls[control.Name].errors?.['minlength'] && formGroup.controls[control.Name].hasError('TooWeakForMediumPassword')">
        {{'TooWeakPassword' | translate}} {{' ,'}} {{'MedumPasswordError' | translate}}
      </span>
      <span class="text-danger" *ngIf="!formGroup.controls[control.Name].errors?.['minlength'] && !formGroup.controls[control.Name].hasError('TooWeakForMediumPassword') && formGroup.controls[control.Name].hasError('MediumPassword')">
        {{'WeakPassword' | translate}} {{' ,'}} {{'MedumPasswordError' | translate}}
      </span>

      <span class="text-danger" *ngIf="!formGroup.controls[control.Name].errors?.['minlength'] && formGroup.controls[control.Name].hasError('TooWeakForComplexPassword')">
        {{'TooWeakPassword' | translate}} {{' ,'}} {{'ComplexPasswordError' | translate}}
      </span>
      <span class="text-danger" *ngIf="!formGroup.controls[control.Name].errors?.['minlength'] && !formGroup.controls[control.Name].hasError('TooWeakForComplexPassword') && formGroup.controls[control.Name].hasError('WeakForComplexPassword')">
        {{'WeakPassword' | translate}} {{' ,'}} {{'ComplexPasswordError' | translate}}
      </span>
      <span class="text-danger" *ngIf="!formGroup.controls[control.Name].errors?.['minlength'] && !formGroup.controls[control.Name].hasError('TooWeakForComplexPassword') && !formGroup.controls[control.Name].hasError('WeakForComplexPassword') && formGroup.controls[control.Name].hasError('ComplexPassword')">
        {{'MediumPassword' | translate}} {{' ,'}} {{'ComplexPasswordError' | translate}}
      </span>
</span>
